import { useEffect, useState } from 'react'
import type { AppCore } from '@core/bootstrap'
import type { ScaleStatus } from '@core/services/scales/ScalesService'
import { hint } from '@ui/classes'
import { eqBtn, okBanner } from '@ui/admin'
import { Alert, Check } from '@ui/icons'

/**
 * Карточка статуса весов: порт/протокол/режим, либо «нет устройства».
 * Подписывается на core.scales.onStatus (push при изменении).
 */
export function ScalesStatusCard({ core }: { core: AppCore }) {
  const [status, setStatus] = useState<ScaleStatus>(() => core.scales.getStatus())

  useEffect(() => {
    const off = core.scales.onStatus((next) => setStatus(next))
    core.scales.requestStatus()
    return off
  }, [core.scales])

  return (
    <div>
      {status.connected ? (
        <p className={okBanner}>
          <Check size={16} /> {status.port ?? '—'} · {status.protocol ?? '—'} · {status.mode ?? '—'}
          {status.baudRate ? ` · ${status.baudRate} baud` : ''}
        </p>
      ) : (
        <p className="my-1.5 inline-flex items-center gap-1 text-small font-semibold text-amber-700">
          <Alert size={16} /> {status.starting ? 'поиск устройства…' : 'нет устройства'}
        </p>
      )}
      {status.error && <p className={hint}>Ошибка: {status.error}</p>}
      <button className={eqBtn} onClick={() => core.scales.requestStatus()}>
        Обновить
      </button>
    </div>
  )
}
